export const navLinks = [
  { id: 'entry', label: '入口导航' },
  { id: 'address', label: '最新地址' },
  { id: 'app', label: 'App 下载' },
  { id: 'safety', label: '防伪指南' },
  { id: 'feed', label: '今日看点' },
  { id: 'faq', label: '常见问题' },
];

export const statusItems = [
  { label: '入口状态', value: '可访问' },
  { label: '线路数量', value: '3 条' },
  { label: '最近巡检', value: '今日 09:20' },
  { label: 'App 版本', value: 'v6.2.1' },
];

export const tickerItems = [
  '主线入口今日巡检正常，加载速度稳定',
  '备用线路 2 已恢复，建议保留收藏夹地址',
  'Android 客户端更新至 v6.2.1，修复启动白屏',
  '近期出现多个仿冒站点，请按核对清单辨别',
  '请勿在第三方页面填写账号密码或支付信息',
];

export const entryTabs = [
  {
    id: 'main',
    label: '官网入口',
    title: '官方主入口',
    desc: '优先使用浏览器记住的主站地址访问，入口每日巡检一次，遇到无法打开时再切换备用线路。',
    icon: 'ri-global-line',
    items: [
      '在浏览器地址栏手动输入你第一次收藏的官方地址，不通过搜索引擎跳转',
      '确认页面顶部有统一的品牌标识与公告栏，版式与其他页面一致',
      '如提示证书异常、要求下载未知插件，立即停止并改用备用线路',
      '访问成功后建议将地址加入书签，并同步一份到手机备忘录',
    ],
  },
  {
    id: 'backup',
    label: '备用线路',
    title: '备用线路与镜像',
    desc: '主入口偶尔会因网络波动短暂不可用，此时可依次尝试官方公布的备用线路，不要相信陌生私信发来的链接。',
    icon: 'ri-route-line',
    items: [
      '备用线路由官方维护，域名结构与主站保持一致的前后缀规律',
      '同一时间只使用官方公告中列出的线路，不尝试未公布的地址',
      '备用线路内容与主入口完全同步，无需重新注册或重复登录',
      '若三条线路同时无法访问，通常是本地上网环境问题，可稍后再试',
    ],
  },
  {
    id: 'app',
    label: 'App 下载',
    title: '客户端下载入口',
    desc: 'App 端相对网页端更稳定，下载只从官方页面提供的安装包获取，避免第三方应用市场的二次打包版本。',
    icon: 'ri-smartphone-line',
    items: [
      'Android 下载对应 .apk 安装包，安装前确认文件来源为官方页面',
      'iOS 端通过官方指引安装，不点击来源不明的描述文件',
      '安装完成后在设置中核对版本号与官方公布的版本一致',
      '首次打开若要求授予无关权限（如通讯录、短信），请谨慎拒绝',
    ],
  },
];

export const addressHistory = [
  { date: '2026-10-10', label: '主线入口', status: '巡检正常', note: '响应稳定，无需更换' },
  { date: '2026-10-06', label: '备用线路 2', status: '已恢复', note: '运营商线路调整完成' },
  { date: '2026-09-28', label: '备用线路 1', status: '巡检正常', note: '保持可用，作为次选' },
  { date: '2026-09-15', label: 'App 下载页', status: '已更新', note: '同步 v6.2.0 安装包' },
  { date: '2026-09-02', label: '主线入口', status: '已优化', note: '访问速度提升，图片加载更快' },
];

export const checklist = [
  '地址与官方公告前后缀规律一致',
  '页面顶部有统一品牌标识与公告栏',
  '不要求安装任何浏览器插件',
  '不索要短信验证码或支付信息',
  '域名证书正常，无安全警告',
];

export const downloadSteps = [
  { icon: 'ri-search-eye-line', title: '确认官方来源', desc: '从官方页面进入下载专区，不要点击私信、群聊里转发的安装包链接。' },
  { icon: 'ri-download-2-line', title: '选择对应平台', desc: '按手机系统选择 Android 安装包或 iOS 安装指引，两者版本号保持一致。' },
  { icon: 'ri-shield-check-line', title: '安装前校验', desc: '安装时系统会提示来源信息，核对与官方公布的文件名、版本一致后再继续。' },
  { icon: 'ri-refresh-line', title: '安装后更新', desc: '首次打开后进入设置检查更新，确保运行的是最新 v6.2.1 版本。' },
];

export const versionRows = [
  { platform: 'Android', version: 'v6.2.1', size: '38.4 MB', requirement: 'Android 8.0 及以上', channel: '官网安装包' },
  { platform: 'iOS', version: 'v6.2.1', size: '52.1 MB', requirement: 'iOS 14.0 及以上', channel: '官方安装指引' },
  { platform: '网页版', version: '即时同步', size: '无需安装', requirement: '主流现代浏览器', channel: '主入口 / 备用线路' },
];

export const fakeSigns = [
  { icon: 'ri-alarm-warning-line', title: '要求下载插件', desc: '仿冒站常提示"需安装加速插件才能访问"，官方站点不会要求安装浏览器扩展。' },
  { icon: 'ri-lock-unlock-line', title: '索要账号密码', desc: '非官方页面突然弹出登录框要求重新验证，多为钓鱼页面，切勿填写。' },
  { icon: 'ri-money-cny-circle-line', title: '诱导付费充值', desc: '以"解锁内容""激活会员"为由要求转账或扫码支付，与官方流程不符。' },
  { icon: 'ri-links-line', title: '域名高度相似', desc: '仿冒地址只在个别字母或后缀上与官方不同，需逐字核对收藏的地址。' },
];

export const feedTags = [
  { id: 'all', label: '全部' },
  { id: 'entry', label: '入口动态' },
  { id: 'app', label: '客户端' },
  { id: 'safety', label: '安全提醒' },
  { id: 'guide', label: '使用技巧' },
];

export const feedItems = [
  { id: 1, tag: 'entry', tagLabel: '入口动态', title: '主线入口完成本季度巡检', summary: '运维团队对主线入口进行例行巡检，页面加载与线路切换均正常，暂不需要调整收藏地址。', time: '今日 09:20', hot: true, img: 'https://readdy.ai/api/search-image?query=warm%20amber%20abstract%20network%20nodes%20map%20on%20deep%20charcoal%20background%2C%20minimal%20editorial%20tech%20visual%2C%20soft%20orange%20glow%2C%20no%20text&width=800&height=600&seq=baoliao-feed-01&orientation=landscape' },
  { id: 2, tag: 'app', tagLabel: '客户端', title: 'Android v6.2.1 修复启动白屏', summary: '本次更新主要修复部分机型冷启动时的白屏问题，并优化了弱网环境下的图片加载策略。', time: '今日 08:05', hot: true, img: 'https://readdy.ai/api/search-image?query=modern%20smartphone%20on%20warm%20orange%20studio%20background%20showing%20abstract%20app%20interface%2C%20clean%20minimal%20product%20photography%2C%20soft%20shadow&width=800&height=600&seq=baoliao-feed-02&orientation=landscape' },
  { id: 3, tag: 'safety', tagLabel: '安全提醒', title: '识别三类常见仿冒套路', summary: '近期仿冒站点多通过相似域名、虚假弹窗与诱导付费实施诈骗，遇到此类情况请立即关闭页面。', time: '昨日 21:40', hot: false, img: 'https://readdy.ai/api/search-image?query=abstract%20shield%20concept%20in%20warm%20bronze%20and%20amber%20tones%2C%20minimal%20geometric%20shapes%2C%20soft%20studio%20lighting%2C%20dark%20background&width=800&height=600&seq=baoliao-feed-03&orientation=landscape' },
  { id: 4, tag: 'guide', tagLabel: '使用技巧', title: '把地址存成书签的正确方式', summary: '建议同时保存主入口与一条备用线路，并开启浏览器的书签同步，换设备也能一键找回。', time: '昨日 16:12', hot: false, img: 'https://readdy.ai/api/search-image?query=open%20notebook%20with%20bookmark%20concept%20on%20warm%20cream%20desk%2C%20soft%20natural%20light%2C%20minimal%20editorial%20still%20life%2C%20amber%20accents&width=800&height=600&seq=baoliao-feed-04&orientation=landscape' },
  { id: 5, tag: 'entry', tagLabel: '入口动态', title: '备用线路 2 已恢复使用', summary: '此前因运营商线路调整短暂不可用的备用线路 2 已完成恢复，可作为主入口的次选方案。', time: '10-06 10:30', hot: false, img: 'https://readdy.ai/api/search-image?query=abstract%20network%20routing%20lines%20in%20warm%20orange%20and%20bronze%20tone%20on%20dark%20background%2C%20minimal%20tech%20illustration%2C%20no%20text&width=800&height=600&seq=baoliao-feed-05&orientation=landscape' },
  { id: 6, tag: 'guide', tagLabel: '使用技巧', title: '弱网环境下的访问建议', summary: '当页面加载缓慢时，可先切换为备用线路，或关闭其他占网应用后重试，通常能明显改善。', time: '10-04 19:05', hot: false, img: 'https://readdy.ai/api/search-image?query=warm%20amber%20wifi%20signal%20waves%20abstract%20minimal%20visual%20on%20deep%20brown%20background%2C%20soft%20glow%2C%20no%20text&width=800&height=600&seq=baoliao-feed-06&orientation=landscape' },
];

export const faqs = [
  { q: '为什么收藏的地址有时打不开？', a: '网络线路、运营商策略或本地环境变化都可能导致短时无法访问。建议先刷新重试，再切换官方公布的备用线路；若三条线路同时不可用，通常是本地上网环境的问题，可稍后再试。' },
  { q: '官网入口和备用线路内容一样吗？', a: '是同一套内容。备用线路由官方维护，数据与主入口完全同步，不需要重新注册或重新登录，仅作为主入口不可用时的替代方案。' },
  { q: 'App 从哪里下载最安全？', a: '只从官方页面提供的下载专区获取安装包，避免使用第三方应用市场的二次打包版本。安装前核对文件名与版本号与官方公布的一致。' },
  { q: '如何判断一个地址是不是仿冒的？', a: '逐字核对收藏的地址，确认页面顶部品牌标识统一、证书正常，且不会要求安装插件、索要验证码或诱导付费。可对照页面的"地址核对清单"逐项确认。' },
  { q: '地址更新后需要重新收藏吗？', a: '主线入口长期稳定时无需改动。只有在官方公告提示更换地址，或连续多次无法访问时，才需要按最新说明更新你的收藏夹。' },
  { q: '遇到疑似仿冒站点该怎么办？', a: '立即关闭页面，不要填写任何账号、验证码或支付信息，也不要点击页面上的下载提示。之后改用自己收藏的官方地址访问。' },
];